<div [formGroup]="form">
    <mat-form-field *ngIf="countryList.length" appearance="fill" class="w-full">
        <mat-label>País</mat-label>
        <mat-select formControlName="countryId" placeholder="Seleccione un país">

            <mat-option *ngFor="let country of countryList" [value]="country._id">
                {{ country.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="departmentList.length" appearance="fill" class="w-full">
        <mat-label>Departamento</mat-label>
        <mat-select formControlName="departmentId" placeholder="Seleccione un Departamento" multiple>

            <mat-select-trigger>
                {{ getDisplayValue(departmentList, form.get('departmentId')?.value, "name")}}
            </mat-select-trigger>

            <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchDepartment" [ngModelOptions]="{ standalone: true }"
                    placeholderLabel="Buscar Departamento..." noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterDepartment($event)">
                </ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let department of filteredDepartmentList" [value]="department._id">
                {{ department.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="cityList.length" appearance="fill" class="w-full">
        <mat-label>Ciudad</mat-label>
        <mat-select formControlName="cityId" placeholder="Seleccione una Ciudad" multiple>

            <mat-select-trigger>
                {{ getDisplayValue(cityList, form.get('cityId')?.value, "name")}}
            </mat-select-trigger>

            <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchCity" [ngModelOptions]="{ standalone: true }"
                    placeholderLabel="Buscar Ciudad..." noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterCity($event)">
                </ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let city of filterdCityList" [value]="city._id">
                {{ city.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="rejectionTypeList.length && !rejectionTypeById" appearance="fill" class="w-full">
        <mat-label>Tipos de Rechazo</mat-label>
        <mat-select formControlName="rejectionTypeId" placeholder="Seleccione un tipo de rechazo" multiple>

            <mat-select-trigger>
                {{ getDisplayValue(rejectionTypeList, form.get('rejectionTypeId')?.value, "name")}}
            </mat-select-trigger>

            <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchRejectionType" [ngModelOptions]="{ standalone: true }"
                    placeholderLabel="Buscar tipos de rechazo..." noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterRejectionType($event)">
                </ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let rejectionType of filteredRejectionTypeList" [value]="rejectionType._id">
                {{ rejectionType.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="rejectionTypeList.length && rejectionTypeById" appearance="fill" class="w-full">
        <mat-label>Tipos de Rechazo</mat-label>
        <mat-select formControlName="rejectionTypeId" placeholder="Seleccione un tipo de rechazo" multiple>

            <mat-select-trigger>
                {{ getDisplayValue(rejectionTypeList, form.get('rejectionTypeId')?.value, "name")}}
            </mat-select-trigger>

            <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchRejectionType" [ngModelOptions]="{ standalone: true }"
                    placeholderLabel="Buscar tipos de rechazo..." noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterRejectionType($event)">
                </ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let rejectionType of filteredRejectionTypeList" [value]="rejectionType.id">
                {{ rejectionType.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>
